import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
// import { environment } from "../../../environments/environment";
// import { VendorOAuthRegistrationUser } from '../shared-emails/Integration/model/models';
import { Observable, Subject } from 'rxjs';
import { AccountUserService } from 'src/app/service/account.service';
import { environment } from 'src/environments/environment';
import { ActivityGroupListPayload, ActivityListPayload, ReadActivitiesByIdsPayload, ReadUnreadActivityStatusPayload } from '../../models/activity-list-payload.model';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  appUrl = "";
  activity = "";
  activityAPI = "";
  user: any;
  constructor(private http: HttpClient, private accountUserService: AccountUserService) {
    this.accountUserService.user.subscribe(x => this.user = x);
    this.appUrl = environment.apiUrl;
    this.activity = environment.localApiUrl;
    this.activityAPI = environment.activity;
  }


  getAllObjects() {
    return this.http.get(environment.configUrl + "LionO360_Object")
      .toPromise()
      .then(res => res);
  }

  getAllObjectTasks(objectID: number, objectTypeID: number) {
    return this.http.get(environment.activity + "/LionO360/2.0/API/ObjectTask/Task?", {
      params: new HttpParams().append("objectId", objectID.toString()).append("objectTypeId", objectTypeID.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAllTasksFromNoteId(noteId: number) {
    return this.http.get(environment.activity + "/LionO360/2.0/API/ObjectTask/TaskForNote", {
      params: new HttpParams().append("noteId", noteId.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAllObjectEvents(objectID: number, objectTypeID: number) {
    return this.http.get(`${this.activityAPI}/LionO360/2.0/API/ObjectCalendarEvent?objectId=${objectID}&objectTypeId=${objectTypeID}`,)
      .toPromise()
      .then(res => res);
  }

  updateEvents(updatedEvent:any): Observable<any> {
    return this.http.put(`${this.activityAPI}/LionO360/2.0/API/CalendarEvent`, updatedEvent);
  }

  getAllObjectNotes(objectID: number, objectTypeID: number) {
    return this.http.get(this.appUrl + "ObjectNote", {
      params: new HttpParams().append("objectId", objectID.toString()).append("objectTypeId", objectTypeID.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAllObjectLogs(objectID: number, objectTypeID: number) {
    return this.http.get(this.appUrl + "ObjectLog", {
      params: new HttpParams().append("objectId", objectID.toString()).append("objectTypeId", objectTypeID.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getAllObjectEmailAudits(objectID: number, objectTypeID: number) {
    return this.http.get<any>(this.activity + "ObjectEmailAudit").toPromise().then(res => res);
    // , {
    //   params: new HttpParams().append("objectId", objectID.toString()).append("objectTypeId", objectTypeID.toString())
    // }
  }

  getTaskDetails(taskId) {
    return this.http.get(environment.activity + "/LionO360/2.0/API/Task/" + taskId)
      .toPromise()
      .then(res => res);
  }

  getNoteDetails(noteId) {
    return this.http.get(this.appUrl + "Note/" + noteId)
      .toPromise()
      .then(res => res);
  }

  getLogDetails(logId) {
    return this.http.get(this.appUrl + "Log/" + logId)
      .toPromise()
      .then(res => res);
  }

  getEmailAuditDetails(emailId) {
    return this.http.get(this.activity + "ObjectEmailAudit/" + emailId)
      .toPromise()
      .then(res => res);
  }

  getAllActivityLogs(objectId: number) {
    return this.http.get<any>(environment.activity + "/LionO360/2.0/API/ObjectTask?", {
      params: new HttpParams().append("objectId", objectId.toString())
    })
      .toPromise()
      .then(res => res);
  }

  getSidebarActivities(objectId: number, objectTypeId: number, fromDate, filter: string, PageNumber: number, PageSize: number) {
    return this.http.get<any>(environment.activity + "/LionO360/2.0/API/Activity/GetSidebarActivities?", {
      params: new HttpParams().
        append("objectId", objectId).
        append("objectTypeId", objectTypeId).
        append("fromDate", fromDate).
        append("filter", filter).
        append("PageNumber", PageNumber).
        append("PageSize", PageSize)
    })
      .toPromise()
      .then(res => res);
  }

  getSidebarNotifications(objectId: number, objectTypeId: number, PageNumber: number, PageSize: number) {
    return this.http.get<any>(environment.activity + "/LionO360/2.0/API/Activity/GetSidebarNotification?", {
      params: new HttpParams().
        append("objectId", objectId).
        append("objectTypeId", objectTypeId).
        append("PageNumber", PageNumber).
        append("PageSize", PageSize)
    })
      .toPromise()
      .then(res => res);
  }

  toggleFavourite(id: number, isFavorite: boolean, filter: string) {
    return this.http.put<any>(`${environment.activity}/LionO360/2.0/API/Activity/favorite?Id=${id}&Isfavorite=${isFavorite}&filter=${filter}`, {})
      .toPromise()
      .then(res => res);
  }

  getNoteById(noteId) {
    return this.http.get(environment.activity + "/LionO360/2.0/API/Note/" + noteId).toPromise().then(res => res);
  }

  getEmailReplyActivity(activityId: number) {
    return this.http.get(environment.activity + "/LionO360/2.0/API/ActivityFeed/GetById/" + activityId).toPromise().then(res => res);
  }

  getEmailSync(objectId: number, objectTypeId: number, emailAuditId: number = 0) {
    return this.http.get(`${environment.activity}/LionO360/2.0/API/Activity/EmailSync?objectId=${objectId}&objectTypeId=${objectTypeId}&emailAuditId=${emailAuditId}`);
  }


  stageWiseActivities(moduleId: number, channelId: number, stageId: number, moduleRecordId: number, filter: string = null, activityType: string|null = null): Observable<any> {
    let params = new HttpParams();

    if (moduleId > 0)
      params = params.append('moduleId', moduleId);

    if (channelId > 0)
        params = params.append('channelId', channelId);

    if (stageId > 0)
        params = params.append('stageId', stageId);

    if (moduleRecordId > 0)
      params = params.append('moduleRecordId', moduleRecordId);

    if (filter)
      params = params.append('filter', filter);

    if (activityType)
        params = params.append('activityType', activityType);

    return this.http.get(environment.activity + "/LionO360/2.0/API/V2/Activity/StageWiseActivities", {params});
  }

  getActivityList(requestPayload: ActivityListPayload): Observable<any> {
    return this.http.post(environment.activity + "/LionO360/2.0/API/V2/Activity/GetActivityList", requestPayload);
  }

  getActivityGroupList(requestPayload: ActivityGroupListPayload): Observable<any> {
    return this.http.post(environment.activity + "/LionO360/2.0/API/V2/Activity/GetGroupedActivityList", requestPayload);
  }

  readUnreadActivityStatus(requestPayload: ReadUnreadActivityStatusPayload): Observable<any> {
    return this.http.post(environment.activity + "/LionO360/2.0/API/V2/Activity/MarkReadUnreadStatus", requestPayload);
  }

  readActivitiesByIds(requestPayload: ReadActivitiesByIdsPayload[]): Observable<any> {
    return this.http.post(environment.activity + "/LionO360/2.0/API/V2/Activity/MarkReadUnreadStatusAssociatedModule", requestPayload);
  }

}
